import { useQuery } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { dsoProductService } from 'services';

interface UseDsoFetchFavouriteProductIdsOptions {
  enabled?: boolean;
}

export const useDsoFetchFavouriteProductIds = (
  options?: UseDsoFetchFavouriteProductIdsOptions
) => {
  return useQuery(
    ServerStateKeysEnum.dsoFavouriteProductIds,
    () => dsoProductService.getDsoFavouriteProductIds(),
    {
      staleTime: Infinity,
      enabled: options?.enabled ?? true,
    }
  );
};
